import { FC } from 'react';
import { Image, ImageProps } from '@chakra-ui/react';
import { ERC20Token } from 'types';

type Props = ImageProps & {
  asset: ERC20Token | null;
};

const TokenIcon: FC<Props> = ({ asset, ...rest }) => {
  return (
    <Image
      boxSize='24px'
      objectFit='cover'
      ignoreFallback
      src={asset?.imageUrl}
      alt={asset?.symbol}
      {...rest}
    />
  );
};

export default TokenIcon;
